import checkmateApi from "../axios/checkmateApi"
import { IUser } from "../slices/userSlice";

export const getUserList = async () => {
    const response = checkmateApi({
        method: 'GET',
        url: 'users?fields=id,name,email,teams,tenantId'
    });
    return response;
}

export const getUserDetails = async (userId: string) => {
    const response = checkmateApi({
        method: 'GET',
        url: `users/${userId}`
    });
    return response;
}

export const createUser = async (user: IUser) => {
    const response = checkmateApi({
        method: 'POST',
        url: 'users',
        data: user
    });
    return response;
}

export const updateUser = async (payload: IUser) => {
    const { password, ...data } = payload;
    const response = checkmateApi({
        method: 'PUT',
        url: `users`,
        data
    });
    return response;
}

export const deleteUser = async (id: string) => {
    return checkmateApi({
        method: 'DELETE',
        url: `users/${id}`
    });
}

export const createSupportTicket = async (ticket: any) => {
    return checkmateApi({
        method: 'POST',
        url: 'support/tickets',
        data: ticket
    });
}

export const getUserTeamDetails = async (teamIds: string) => {
    return checkmateApi({
        method: 'GET',
        url: `teams?id=${teamIds}`
    });
}